const SignupPaymentActionType = {
  SUBMIT_SIGNUP: 'PAYMENT_SUBMIT_SIGNUP',
  RESET_ALL: 'PAYMENT_RESET_ALL',
  STORE_PAYMENT_DETAILS: 'PAYMENT_STORE_PAYMENT_DETAILS',
  VALIDATE_PROMO_CODE: 'PAYMENT_VALIDATE_PROMO_CODE',
  CLICK_GATEWAY_DETAILS: 'PAYMENT_CLICK_GATEWAY_DETAILS',
  CLICK_ERROR_MESSAGE_UPDATE: 'CLICK_ERROR_MESSAGE_UPDATE'
};

export default SignupPaymentActionType;



/** WEBPACK FOOTER **
 ** ./src/common/SignupPaymentActionType.js
 **/